import type { ReactNode } from 'react';
import { useI18n } from '@/client/i18n/I18nContext';

export function LoadingState({ label }: { label?: string }) {
  const { t } = useI18n();
  return (
    <div className="state" role="status" aria-live="polite">
      <div className="spinner" />
      <p>{label ?? t('common.loading')}</p>
    </div>
  );
}

export function ErrorState({
  title,
  message,
  action,
}: {
  title?: string;
  message?: string;
  action?: ReactNode;
}) {
  const { t } = useI18n();
  title = title ?? t('states.errorTitle');
  message = message ?? t('states.errorMsg');
  return (
    <div className="state" role="alert">
      <h2>{title}</h2>
      <p>{message}</p>
      {action ? <div className="mt-6">{action}</div> : null}
    </div>
  );
}

export function EmptyState({
  title,
  message,
  action,
}: {
  title: string;
  message?: string;
  action?: ReactNode;
}) {
  return (
    <div className="state">
      <h2>{title}</h2>
      {message ? <p>{message}</p> : null}
      {action ? <div className="mt-6">{action}</div> : null}
    </div>
  );
}
